<!-- 订单评价 -->
<template>
  <div>
    <header class="search-title">
      <span class="title-text" @click="toOrder"><i class="el-icon-arrow-left" /> 订单管理</span>
    </header>
    <div class="order-evaluate">
      <div class="eva-left">
        <img :src="stockData.path" alt="">
        <div class="goods-name">{{ stockData.stock }}</div>
      </div>
      <div class="eva-right">
        <div class="eva-rate"><span>商品评价</span><el-rate v-model="value4" /></div>
        <div class="eva-rate"><span>质量评价</span><el-rate v-model="value1" /></div>
        <div class="eva-rate"><span>物流评价</span><el-rate v-model="value2" /></div>
        <div class="eva-rate"><span>服务评价</span><el-rate v-model="value3" /></div>

        <div class="eva-text">
          <div>评价内容</div>
          <textarea v-model="content" class="eva-content" placeholder="多行输入" maxlength="100" />
        </div>
        <div class="eva-img">
          <!-- <el-upload
          ref="otherLicense"
          class="avatar-uploader"
          :class="{disabled:uploadDisabled}"
          action
          :auto-upload="false"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-change="otherSectionFile"
          list-type="picture-card"
          multiple
        >
          <div class="uploadDiv">
            <svg-icon icon-class="upload-image" />
            <span class="uploadText">上传图片</span>
          </div>

        </el-upload> -->
          <span v-for="(item,index) in fileList" :key="index" class="prod-picture-list" @mouseenter="pictureEnters(index)" @mouseleave="pictureLeaver(index)">
            <div v-if="picHover === index" class="prod-picture-hover">
              <i class="el-icon-delete" @click="handleRemove(index)" />
            </div>
            <img v-if="item" :src="item.url" class="prod-picture" alt="">
          </span>

          <el-upload
            v-if="fileList.length < 6"
            ref="upload"
            :class="fileList.length ? '' : 'uploadImg'"
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :on-change="otherSectionFile"
            multiple
          >
            <i slot="default" class="el-icon-plus" />
          </el-upload>
        </div>

        <div class="eva-submit">
          <div @click="onTapBackOrderList">点击提交</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { uploadImg } from '@/api/user.js'
import { appraiseOrder } from '@/api/order.js'
export default {
  data() {
    return {
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      fileList: [],
      stockData: {},
      picHover: '',
      loading: null,
      content: ''
    }
  },
  created() {
    this.stockData = JSON.parse(this.$route.query.stockObj)
  },
  methods: {
    toOrder() {
      this.$router.push({
        name: 'MyOrderManagement',
        params: {
          orderStatus: this.$route.query.orderStatus
        }
      })
    },
    otherSectionFile(file) {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const formData = new FormData()
      formData.append('file', file.raw)
      uploadImg(formData)
        .then(res => {
          if (res.result) {
            const obj = {
              url: res.imgUrlList[0].oriUrl
            }
            this.fileList.push(obj)
          } else {
            this.$message.error(res.imgUrlList[0].message)
          }
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
    },
    handleRemove(index) {
      this.fileList.splice(index, 1)
    },
    handlePreview(file) {
    },
    onTapBackOrderList() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const obj = {
        FQualityStar: this.value1,
        FTransportStar: this.value2,
        FServiceStar: this.value3,
        FStockStar: this.value4,
        FAppraiseComment: this.content,
        Image: JSON.stringify(this.fileList)
      }
      const params = new URLSearchParams()
      params.append('fdetailID', this.stockData.detailId)
      params.append('fid', this.stockData.id)
      params.append('jsonobj', JSON.stringify(obj))
      appraiseOrder(params)
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.$router.back()
          } else {
            this.$message.error(res.msg)
          }
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
    //   this.$router.back()
    },
    /**
     * 鼠标移入商品图片事件
     */
    pictureEnters(index) {
      this.picHover = index
      this.noPrcHover = ''
    },
    /**
     * 鼠标移出商品图片事件
     */
    pictureLeaver() {
      this.picHover = ''
    }
  }
}
</script>

<style lang='scss'>
.search-title{
    display: flex;
    justify-content: space-between;
    width:100%;
    height: 45px;
    line-height: 45px;
    background-color: #EC212D;
    .title-text{
      cursor: pointer;
      color:#fff;
      font-size: 16px;
      margin-left: 11px;
    }
  }
.order-evaluate{
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 21px 83px;
  display: flex;
  .uploadImg {
      margin-top: 20px;
  }
  .el-upload-list--picture-card {
      display: none !important;
  }
  .prod-picture-list{
      margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
  margin-right: 13px;
  display: flex;
  flex-direction: column;
  text-align: center;
  .prod-picture{
    width: 148px;
    height: 148px;
    border: 1px solid #D2D2D2;
    border-radius: 5px;
    pointer-events:none;
  }
  .set-defult{
    font-size: 12px;
    color: #2DB0A0;
    text-decoration: underline;
  }
  .prod-picture-hover{
    width: 148px;
    height: 148px;
    border-radius: 5px;
    // background-color: #000;
    // opacity: 0.7;
    background-color:rgba(0,0,0,0.5);
    position: absolute;
    line-height: 148px;
    text-align: center;
    .el-icon-delete:before{
      color: #fff;
      cursor: pointer;
    }
  }
}
  .eva-left{
    width: 410px;
    height: 800px;
    img{
      width: 410px;
      height: 410px;
    }
    .goods-name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #202020;
      margin-top: 21px;
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2;
      width: 100%;
    }
  }
  .eva-right{
    flex: 1;
    height: 700px;
    margin-left: 60px;
    .eva-rate{
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
      border-bottom: 2px dashed rgba($color: #dcdcdc, $alpha: 0.5);
      flex-wrap: nowrap;
      .el-rate{
        height: 40px;
        margin-left: 14px;
      }
      .el-rate__icon{
        font-size: 35px;
      }
    }
    .eva-text{
      width: 100%;
      height: 130px;
       font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      display: flex;
      margin-top: 20px;
      div{
        margin-right: 14px;
      }
      .eva-content{
        height: 130px;
        flex: 1;
        border: 1px solid #D2D2D2;
        box-sizing: border-box;
        padding: 10px;
      }
    }
    .eva-img{
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-left: 90px;
    //   margin-top: 20px;
      .upload-demo{
        width: 120px;
        height: 120px;
        border: 1px solid #D2D2D2;
        display: flex;
        align-items: center;
        justify-content: center;

      }
    }
    .eva-submit{
      width: 100%;
      height: 140px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      div{
        width: 220px;
        height: 46px;
        background: #EC212D;
        border-radius: 2px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor:pointer
      }
    }

  }
  .el-upload {
  .uploadDiv {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .svg-icon {
    width: 39px;
    height: 33px;
    }
    .uploadText {
      font-size: 12px;
      font-family: SimSun;
      font-weight: 400;
      color: #D2D2D2;
      line-height: 30px;
    }
    }
    }
}
</style>
